'use strict';

angular.module('ntmApp').factory('ListGridDataService', ['ListGridStatus', 'ListGridHelper', 'ListGridConstants',
    function (ListGridStatus, ListGridHelper, ListGridConstants) {

    function ListGridDataService() {

        var self = this;

        self.getEditDialogData = function (type, gridData, isViewPrimaryKey, entity, listGridActions) {

            return {
                action: type,
                buttons: gridData.actions,
                listGridActions: listGridActions,
                entity: entity,
                doNotReset: true,
                pageType: ListGridConstants.SectionType.Grid,
                pageTitle: gridData.sectionTitle,
                columAnimations: gridData.columAnimations,
                isViewPrimaryKey: isViewPrimaryKey,
                mdPage: ListGridStatus.htmlPageId,
                model: self.getModel(entity),
                searchableData: gridData.searchableData,
                generalPageSection: [{
                    sectionAttributes: gridData.columns,
                    mdPage: gridData.sectionId,
                    displayType: ListGridConstants.DialogDisplayTypes.STACKED,
                    instructions: gridData.instructions,
                    cluetip: gridData.cluetip,
                    sectionHeader: gridData.sectionTitle,
                    showSectionHeader: gridData.showHeader
                }]
            };
        };

        self.getModel = function (entity) {

            if (!entity) {
                return;
            }

            var keys = Object.keys(entity);
            var model = {};

            keys.forEach(function (key) {

                var column = ListGridHelper.getColumnByName(key);

                if (column) {

                    switch (column.type) {
                        case 'TIME':
                            model[column.fieldName] = entity[key] && moment(entity[key]).isValid() ? moment(entity[key]).format('hh:mm A') : null;
                            break;
                        case ('NUMERIC'):
                            if (column.propertyObj.displayAs && (column.propertyObj.displayAs === 'percent' || column.propertyObj.displayAs === 'progressBar')) {
                                model[column.fieldName] = entity[key] / 100;
                            } else {
                                model[column.fieldName] = entity[key];
                            }
                            break;
                        case ('RADIOBOOLEAN'):
                            model[column.fieldName] = entity[key] === 'Yes' ? true : entity[key] === 'No' ? false : null;
                            break;
                        case ('CHECKBOXLIST'):
                            if (entity[key]) {
                                if (angular.isArray(entity[key])) {
                                    entity[key] = entity[key].map(function (item) { return item.id; }).join(';');
                                } 
                                model[column.fieldName] = entity[key];
                            }
                            break;
                        default:
                            model[column.fieldName] = entity[key];
                    }
                    
                }
            });

            return model;
        };

    }

    return (ListGridDataService);
}]);